import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toJson',
  standalone: true,
})
export class ToJsonPipe implements PipeTransform {
  transform(value: string): unknown {
    try {
      return JSON.parse(value);
    } catch {
      return null;
    }
  }
}
